<template>
  <section class="rooms fadeIn animated">
    <div :class="['room','animated', this.route]">
      <div class="background"></div>
      <div class="text easeOutCubic">
        <div class="box">
          <h1>{{(this.route === 'single')? this.current_lang.room[0] : this.current_lang.room[1] }} 
            <div class="switch bounceInDown animated" v-on:click="roomChange()">
              <router-link :to="'../../'+this.langs+'/rooms/double'" v-if="this.route === 'single'"><i class="fas fa-chevron-up"></i></router-link>
              <router-link :to="'../../'+this.langs+'/rooms/single'" v-else ><i class="fas fa-chevron-down"></i></router-link>
            </div>
          </h1>
          <div class="price"><span>{{this.current_lang.room[27]}} <br><span>{{this.current_lang.room[30]}}</span></span><strong>${{(this.route === 'single')? '80': '100'}}</strong> /{{this.current_lang.room[3]}}</div>
          <div class="description">
            <div v-if="this.route === 'single'">
              <p>{{this.current_lang.room[4]}}</p>
              <ul>
                <li>{{this.current_lang.room[5]}}</li>
                <li>{{this.current_lang.room[6]}}</li>
                <li>{{this.current_lang.room[7]}}</li>
                <li>{{this.current_lang.room[8]}}</li>
                <li>{{this.current_lang.room[9]}}</li>
                <li>{{this.current_lang.room[10]}}</li>
                <li>{{this.current_lang.room[11]}}</li>
                <li>{{this.current_lang.room[12]}}</li>
                <li>{{this.current_lang.room[13]}}</li>
              </ul>
              <p>{{this.current_lang.room[14]}} / {{this.current_lang.room[15]}} <br>{{this.current_lang.room[28]}}</p>
            </div>
            <div v-else>
              <p>{{this.current_lang.room[16]}}</p>
              <ul>
                <li>{{this.current_lang.room[17]}}</li>
                <li>{{this.current_lang.room[18]}}</li>
                <li>{{this.current_lang.room[19]}}</li>
                <li>{{this.current_lang.room[20]}}</li>
                <li>{{this.current_lang.room[21]}}</li>
                <li>{{this.current_lang.room[22]}}</li>
                <li>{{this.current_lang.room[23]}}</li>
                <li>{{this.current_lang.room[24]}}</li>
                <li>{{this.current_lang.room[25]}}</li>
              </ul>
              <p>{{this.current_lang.room[14]}} / {{this.current_lang.room[15]}} <br>{{this.current_lang.room[28]}}</p>
            </div>
          </div>
          <a id="reserve" class="reserve easeOutCubic" v-on:click="reserve()">{{this.current_lang.room[26]}} <i class="fas fa-calendar-alt"></i></a>
        </div>
      </div>
    </div>

    <div class="modal-reserve">
      <div class="item">
        <form class="confirm form-villavela" action="reserve" :room="this.$route.params.room">
          <h2>{{this.current_lang.home[0]}} {{this.current_lang.home[1]}}</h2>
          <input type="text" name="name" :placeholder="this.current_lang.home[16]" required>
          <input type="email" name="email" placeholder="@mail.com" required>
          <input type="number" name="phone" :placeholder="this.current_lang.home[17]" required>
          <button class="easeOutCubic">{{this.current_lang.home[19]}} <i class="fas fa-anchor"></i> <i id="rotating" class="fa fa-spinner faa-spin"></i></button>
        </form>
      </div>
      <div class="item">
        <form class="date reserve-form" v-on:submit.prevent :room="this.$route.params.room">
          <div class="box start-end">
            <label>{{this.current_lang.home[6]}}</label>
            <DatePicker></DatePicker>
          </div>
          <div class="box persons">
            <label>{{this.current_lang.home[9]}}</label>
            <input type="number" name="people" value="1" min="1" max="4">
          </div>
          <button class="easeOutCubic">{{this.current_lang.home[19]}} <i class="fas fa-anchor"></i> <i id="rotating" class="fa fa-spinner faa-spin"></i></button>
        </form>
      </div>
      <div class="close bounceInUp animated"><i class="fas fa-times-circle"></i></div>
    </div>

  </section>
</template>

<script>
/* eslint-disable */
import {mapState} from 'vuex';
import { DatePicker } from 'ant-design-vue'
import 'ant-design-vue/dist/antd.css'
export default {
  name: 'rooms',
  components: {
    DatePicker: DatePicker.RangePicker
  },
  data(){
    return {
      route: this.$route.params.room,
      langs: this.$route.params.lang,
      room: null 
    }
  },
  computed: {
    ...mapState(['lang'])
  },
  created() {

    $('html,body').scrollTop(0);

    // lang
    this.current_lang = this.lang.es;

    if(this.langs){
      if(this.langs === 'es'){
        this.current_lang = this.lang.es;
      }else if(this.langs === 'en'){
        this.current_lang = this.lang.en;
      }
    }

  },
  mounted() {
    // $('.reserve-slide').find('.item').find('.description').on('click','a', function () {
    //   var room = $(this).parents('.item').find('.reserve-form').attr('room');
    //   var start = $(this).parents('.item').find('.reserve-form').find('.start-end').find('input').eq(0).val();
    //   var end = $(this).parents('.item').find('.reserve-form').find('.start-end').find('input').eq(1).val();
    //   var people = $(this).parents('.item').find('.reserve-form').find('.persons').find('input').val();
      
    //   var data = [start, end, people];
      
    //   localStorage.setItem(room, data);

    // });

    this.formReserve();

    $('.modal-reserve').on('click','.close', function () {
        $('.modal-reserve').removeClass('fadeIn animated').hide();
        $('#app').find('.rooms').find('.room').find('.text').removeClass('fadeInUp fadeInDown blur');
    });

    $('.modal-reserve').find('form.date').on('submit', function (e) {
      e.preventDefault();
      $('.modal-reserve').find('form.confirm').find('button').click();
    });

    $('.form-villavela').on('submit', function (e) {

            e.preventDefault();

            $(this).find('button').addClass('submit');

            var that = $(this);
            
            var action = $(this).attr('action');

            var date = new Date();
            
            var form_subject = null;

            var form_room = null;
            
            var form_html = `<table><tbody>`;

            if(action === 'contact'){

                form_subject = 'Formulario Contáctenos';

                form_html  += `
                    <tr>
                        <td><b>Nombre: </b></td>
                        <td>`+$(this).find('input[name=name]').val()+`</td>
                    </tr>
                    <tr>
                        <td><b>Correo: </b></td>
                        <td>`+$(this).find('input[name=email]').val()+`</td>
                    </tr>
                    <tr>
                        <td><b>Teléfono: </b></td>
                        <td>`+$(this).find('input[name=phone]').val()+`</td>
                    </tr>
                    <tr>
                        <td><b>Mensaje: </b></td>
                        <td>`+$(this).find('textarea[name=message]').val()+`</td>
                    </tr>
                `;
            }else if(action === 'reserve'){

                form_subject = 'Formulario Reservación';

                form_room = $(this).attr('room');

                if(form_room === 'single'){
                  form_room = 'Simple';
                }else if(form_room === 'double'){
                  form_room = 'Doble';
                }
                  
                form_html  += `
                    <tr>
                        <td><b>Nombre: </b></td>
                        <td>`+$(this).find('input[name=name]').val()+`</td>
                    </tr>
                    <tr>
                        <td><b>Correo: </b></td>
                        <td>`+$(this).find('input[name=email]').val()+`</td>
                    </tr>
                    <tr>
                        <td><b>Teléfono: </b></td>
                        <td>`+$(this).find('input[name=phone]').val()+`</td>
                    </tr>
                    <tr><td></td></tr>
                    <tr><td></td></tr>
                    <tr>
                        <td><b>Habitación:</b></td>
                        <td>`+form_room+`</td>
                    </tr>
                    <tr>
                        <td><b>Fecha de llegada y salida:</b></td>
                        <td>`+$('form.date').find('.start-end').find('input').eq(0).val()+` | `+$('form.date').find('.start-end').find('input').eq(1).val()+`</td>
                    </tr>
                    <tr>
                        <td><b>Personas:</b></td>
                        <td>`+$('form.date').find('input[name=people]').val()+`</td>
                    </tr>
                `;
            }

            form_html += `</tbody></table>`;

            // console.log(form_html);

            $.post( "https://hotelvillavela.com/mail.php", { subject: form_subject, html:  form_html})
            .done(function( data ) {
                setTimeout(() => {
                    that.find('button').removeClass('submit');
                    that[0].reset();

                    $('#app.rooms .modal-reserve .close').click();
                }, 3000);
            });

        });
  },
  methods: {
    formReserve: function(){
      $('.modal-reserve').find('.item').each(function (index, element) {
        if(localStorage.getItem( $(this).find('.reserve-form').attr('room'))){
          this.room = localStorage.getItem( $(this).find('.reserve-form').attr('room'));
          this.room = this.room.split(",");
          $(this).find('.reserve-form').find('.start-end').find('input').eq(0).val(this.room[0]);
          $(this).find('.reserve-form').find('.start-end').find('input').eq(1).val(this.room[1]);
          $(this).find('.reserve-form').find('.persons').find('input').val(this.room[2]);
        }else{
          var today = new Date();
          today = today.toISOString().slice(0,10).replace(/-/g,"/");
          $('.modal-reserve').find('.item').find('.reserve-form').find('.start-end').find('input').val(today);
        }
      
      });
    },
    roomChange: function(){
      $('#app').find('.rooms').find('.room').find('.text').removeClass('fadeInUp fadeInDown');
      if(this.route === 'single'){
        $('#app').find('.rooms').find('.room').find('.text').addClass('fadeOutUp');
        setTimeout(() => {    
          this.route = 'double';
        }, 500);
      }else{
        $('#app').find('.rooms').find('.room').find('.text').addClass('fadeOutDown');
        setTimeout(() => {
          this.route = 'single';
        }, 500);
      }
      setTimeout(() => {
        $('#app').find('.rooms').find('.room').find('.text').removeClass('fadeOutUp fadeOutDown');
        if(this.route === 'single'){
        $('#app').find('.rooms').find('.room').find('.text').addClass('fadeInDown');
        }else{
          $('#app').find('.rooms').find('.room').find('.text').addClass('fadeInUp');
        }
      }, 500);

      this.formReserve();
    },
    reserve: function(){
      $('.modal-reserve').addClass('fadeIn animated').show();
      $('#app').find('.rooms').find('.room').find('.text').addClass('blur').removeClass('fadeInUp fadeInDown');
      $('html,body').scrollTop(0);
    }
  },
}
</script>

<style lang="sass">
$primary: #074866
$secundary: #999999
$third: #CCCCCC
a
  cursor: pointer
#app
  &.rooms
    header
      .nav
        margin-left: 3vw
        a
          color: $third
          &:nth-child(2)
            color: $third
            font-weight: 600
      .social-media
        a
          i
            color: $secundary
    .modal-reserve
      position: absolute
      display: none
      width: 100%
      height: 100vh
      top: 0px
      left: 0px
      .item
        display: inline-block
        vertical-align: top
        width: 50%
        height: 100%
        .date
          background: #FFFFFF
          -webkit-box-shadow: 1px 1px 20px 0px rgba(204,204,204,1)
          -moz-box-shadow: 1px 1px 20px 0px rgba(204,204,204,1)
          box-shadow: 1px 1px 20px 0px rgba(204,204,204,1)
          width: 80%
          margin: auto
          padding: 5%
          border-radius: 40px
          position: relative
          top: 50%
          transform: translateY(-50%)
          .box
            display: inline-block
            vertical-align: top
            width: 25%
            text-align: center
            border-radius: 20px
            padding: 40px 0px
            &.start-end
              width: 75%
              .ant-calendar-picker-input
                border: none
              .ant-input
              .ant-calendar-picker-icon
              input
                height: 99%
                outline: 0
                width: 44%
                text-align: center
                font-size: 14px
                font-weight: 200
                display: inline-block
            label
              display: block
              color: $primary
              margin: 0px
              font-weight: 600
              margin-bottom: 20px
              font-size: 1.1vw
              letter-spacing: 0.1vw
            input
              width: 90%
              margin: 0px  0px 0px auto
              display: block
              font-size: 30px
              font-weight: bold
              color: #BDCCD4
              text-align: center
              border: none
          button
            display: none
            background: $primary
            color: #FFFFFF
            border: none
            border-radius: 30px
            padding: 5px 0px
            text-align: center
            width: 180px
            margin: 30px auto 0px auto
            font-size: 16px
            line-height: 26px
            text-decoration: none
            position: relative
            i
              font-size: 0px
              font-weight: 600
              display: none
              &:last-child
                display: none
            &:hover
              background: #FFFFFF
              color: $primary
              font-weight: 700
              border-radius: 0px
              i
                display: inline
                font-size: 16px
                &:last-child
                  display: none
            &.submit
              color: #FFFFFF
              background: #FFFFFF
              i
                color: #FFFFFF
                &.fa-spinner
                  display: block
                  color: $primary
                  position: absolute
                  left: 50%
                  top: 50%
                  font-size: 20px
                  margin-top: -10px
                  margin-left: -10px
        .confirm
          background: #FFFFFF
          -webkit-box-shadow: 1px 1px 20px 0px rgba(204,204,204,1)
          -moz-box-shadow: 1px 1px 20px 0px rgba(204,204,204,1)
          box-shadow: 1px 1px 20px 0px rgba(204,204,204,1)
          width: 80%
          margin: auto
          padding: 10% 5%
          border-radius: 40px
          position: relative
          top: 50%
          transform: translateY(-50%)
          h2
            display: block
            font-family: 'Rozha One', serif
            color: $primary
            font-size: 4vw
            letter-spacing: 0.7vw
            line-height: 4.5vw
            margin: 0px
            text-align: center
          input
            display: block
            width: 80%
            margin: 3vh auto
            border: 1px solid $third
            border-radius: 20px
            padding: 10px 30px
            font-size: 1vw
            color: $secundary
          button
            display: block
            background: $primary
            color: #FFFFFF
            border: none
            border-radius: 30px
            padding: 5px 0px
            text-align: center
            width: 180px
            margin: 30px auto 0px auto
            font-size: 16px
            line-height: 26px
            text-decoration: none
            position: relative
            i
              font-size: 0px
              font-weight: 600
              display: none
              &:last-child
                display: none
            &:hover
              background: #FFFFFF
              color: $primary
              font-weight: 700
              border-radius: 0px
              i
                display: inline
                font-size: 16px
                &:last-child
                  display: none
            &.submit
              color: #FFFFFF
              background: #FFFFFF
              i
                color: #FFFFFF
                &.fa-spinner
                  display: block
                  color: $primary
                  position: absolute
                  left: 50%
                  top: 50%
                  font-size: 20px
                  margin-top: -10px
                  margin-left: -10px
      .close
        position: absolute
        float: none 
        height: 3vw
        width: 3vw
        right: calc(25% - 1.5vw)
        bottom: 25%
        opacity: 1
        text-shadow: none 
        i
          font-size: 3vw
          color: $primary

    .rooms
      display: block
      min-height: 100vh
      overflow: hidden
      .blur
        filter: blur(10px)
        -webkit-filter: blur(10px)
      .room
        display: block
        background: #FFFFFF
        &.single
          .background
            background: url(../assets/images/rooms/single.png)no-repeat 0% 50% /cover
        &.double
          .background
            background: url(../assets/images/rooms/double.png)no-repeat 0% 50% /cover
        .background
          display: inline-block
          vertical-align: top
          height: 100vh
          width: 50%
          background: #2f2f2f
        .text
          display: inline-block
          vertical-align: top
          width: 50%
          height: 100vh
          padding: 0px 5%
          .box
            display: block
            position: relative
            top: 53%
            transform: translateY(-50%)
          h1
            display: inline-block
            vertical-align: top
            font-size: 2vw
            letter-spacing: 0.1vw
            color: $primary
            margin: 0px
            font-weight: 600
            width: 60%
            position: relative
            &:after
              content: ""
              display: block
              width: 100%
              height: 0.8vw
              background: url(../assets/images/wave.png)no-repeat 0% 50% /contain
              margin-top: 0.5vw
            .switch
              display: inline-block
              vertical-align: top
              border: 1px solid $third
              text-align: center
              border-radius: 20px
              cursor: pointer
              margin-top: -0.5vw
              a
                display: block
                text-decoration: none
                color: $primary
                padding: 1vw 0.3vw 1vw 0.45vw
                i
                  display: block
                  font-size: 1vw
                  font-weight: 600
          .price
            color: $primary
            display: inline-block
            vertical-align: top
            width: 40%
            text-align: right
            font-size: 1vw
            strong
              font-size: 2vw
              display: inline-block
              vertical-align: middle
              font-weight: 600
              letter-spacing: 0vw
              margin-top: -8px
              padding-left: 0.5vw
            span
              display: inline-block
              vertical-align: top
              line-height: 1vw
              text-transform: capitalize
              span
                font-size: 1vw
                text-transform: lowercase
          .description
            display: block
            margin-top: 1.5vw
            p 
              display: block
              color: $secundary
              font-size: 1vw
              margin: 0px 0px 1vw
            ul
              display: block
              margin-bottom: 1vw
              li
                color: $secundary
                font-size: 0.9vw
                line-height: 1.5vw

          .carousel-room
            display: block
            width: calc(100% - 150px)
            margin: 2vw auto 0px auto
            position: relative
            .tns-nav
              display: none
            .tns-controls
              button
                z-index: 2
                text-align: center
                width: 60px
                height: 60px
                padding-top: 16px
                border: 3px solid transparent
                background-image: none
                bottom: 35vh
                top: auto
                opacity: 0.3
                border-radius: 100%
                background: $primary
                font-size: 0px
                position: absolute
                top: 50%
                margin-top: -30px
                left: -80px
                &::before
                  display: block
                  height: 100%
                  width: 100%
                  font-size: 25px
                  color: #FFFFFF
                &:last-child
                  left: auto
                  right: -80px
                  &::before
                    margin-left: 2px
                &:hover
                  opacity: 1
            .action-carousel
              display: none
            .tns-item
              overflow: hidden
              position: relative
              height: 150px
              cursor: pointer
              img
                width: 90%
                margin-left: 5%
                position: relative
                top: 50%
                transform: translateY(-50%)
          .reserve
            display: block
            vertical-align: top
            background: $primary
            color: #FFFFFF
            border: none
            border-radius: 30px
            padding: 5px 0px
            text-align: center
            width: 160px
            margin: 4vw 0px 0px 0px
            font-size: 16px
            line-height: 26px
            text-decoration: none
            i
              font-size: 0px
              font-weight: 600
              display: none
            &:hover
              background: #FFFFFF
              color: $primary
              font-weight: 500
              border-radius: 0px
              i
                display: inline
                font-size: 1.2vw


@media(max-width: 1024px)
  .ant-calendar-picker-container
    width: 100%
    margin: auto
  #app
    &.rooms
      header
        .nav
          a
            color: #FFFFFF
            &.router-link-exact-active
              color: $primary
        .social-media
          a
            i
              color: #FFFFFF
      .modal-reserve
        top: 100px
        padding-top: 70px
        .close
          height: 40px
          width: 40px
          bottom: auto
          top: 5%
          right: auto
          left: 50%
          margin-left: -20px
          i
            font-size: 40px
            color: #FFFFFF
        .item
          display: block
          width: 100%
          height: auto
          margin: 20px 0px
          .confirm
            top: 0px
            transform: none
            width: 90%
            border-radius: 0px
            h2
              font-size: 20px
              letter-spacing: 0.3vw
            input
              width: 90%
              font-size: 14px
            button
              display: none
              i
                font-size: 14px !important
          .date
            top: 0px
            transform: none
            width: 90%
            border-radius: 0px
            box-shadow: none
            .box
              display: block
              width: 100%
              max-width: 280px
              padding: 10px 0px
              text-align: left
              box-shadow: none !important
              &.start-end
                display: block
                width: 100%
                .ant-input
                  height: auto
                  width: 100%
                  display: block
                  border: none
                  padding: 0px
                  padding-top: 10px
                .ant-calendar-picker
                  height: auto
                  width: 100%
                  display: block
                .ant-calendar-range-picker-separator, i
                  display: none
                input
                  font-size: 14px
                  line-height: 20px
                  text-align: left
                  padding: 10px 30px
                  width: 100%
                  color: $secundary
                  display: block
                  border: 1px solid $third
                  border-radius: 20px
                  margin-bottom: 10px
              label
                font-size: 14px
                line-height: 20px
                display: block
                margin: 0px
                padding: 10px 0px
              input
                font-size: 14px
                line-height: 20px
                text-align: left
                padding: 10px 30px
                width: 100%
                color: $secundary
                display: block
                border: 1px solid $third
                border-radius: 20px
            button
              display: block
              margin-bottom: 20px
              i
                font-size: 14px !important
  
      .rooms
        .room
          .background
            display: block
            width: 100%
          .text
            display: block
            width: 90%
            background: #FFFFFF
            height: auto
            margin: auto
            padding: 0px
            margin-top: -90px
            &.easeOutCubic
              animation-duration: 0s !important
            .box
                top: 0px
                transform: none
                padding: 40px 10%
                br
                  display: none
                h1
                  width: 100%
                  font-size: 20px
                  line-height: 20px
                  .switch
                    margin-top: -15px
                    margin-left: 20px
                    a 
                      padding: 15px 5px
                      i
                        font-size: 16px
                .price
                  display: block
                  font-size: 16px
                  line-height: 16px
                  text-align: left
                  margin: 20px 0px
                  width: 100%
                  strong
                    font-size: 20px
                    margin-top: -5px
                  span
                    font-size: 16px
                    line-height: 16px
                    display: block
                    margin-bottom: 10px
                    span
                      display: inline
                      margin-bottom: 0px

                .description
                  div
                    p
                      font-size: 16px
                      line-height: 26px
                    ul
                      li
                        font-size: 14px
                        line-height: 24px
                .reserve
                  margin: 40px 0px 40px 0px


</style>